import {createContext} from 'react';

export type ErrorInformerRenderContextValue = null | {id: number};

export const ErrorInformerRenderContext = createContext<ErrorInformerRenderContextValue | null>(null);

ErrorInformerRenderContext.displayName = 'ErrorInformerRenderContext';
